// extracted by mini-css-extract-plugin
export var arrows = "_5u-6";
export var decrementer = "_5u-a";
export var disabled = "_5u-4";
export var error = "_5u-1";
export var hiddenText = "_5u-b";
export var incrementer = "_5u-9";
export var input = "_5u-8";
export var inputWrapper = "_5u-0";
export var leadingIcon = "_5u-c";
export var readonly = "_5u-3";
export var regular = "_5u-7";
export var small = "_5u-5";
export var warning = "_5u-2";